import { Component, type OnInit, inject } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";

import { AccountService } from "../../core";
import { PasswordService } from "./password.service";

@Component({
    selector: "jhi-password",
    templateUrl: "./password.component.html",
    standalone: false,
})
export class PasswordComponent implements OnInit {
    private passwordService = inject(PasswordService);
    private accountService = inject(AccountService);
    private fb = inject(UntypedFormBuilder);

    doNotMatch: string;
    error: string;
    success: string;
    account: any;
    passwordForm = this.fb.group({
        currentPassword: ["", [Validators.required]],
        newPassword: [
            "",
            [
                Validators.required,
                Validators.minLength(8),
                Validators.maxLength(50),
                Validators.pattern(".*[A-Z]+.*"),
                Validators.pattern(".*[a-z]+.*"),
                Validators.pattern(".*[0-9]+.*"),
                Validators.pattern(".*[!@#$/?%^&*=+;:,.<>()_-]+.*"),
            ],
        ],
        confirmPassword: [
            "",
            [
                Validators.required,
                Validators.minLength(8),
                Validators.maxLength(50),
            ],
        ],
    });

    ngOnInit() {
        this.accountService.identity().then((account) => {
            this.account = account;
        });
    }

    changePassword() {
        const newPassword = this.passwordForm.get(["newPassword"]).value;
        if (newPassword !== this.passwordForm.get(["confirmPassword"]).value) {
            this.error = null;
            this.success = null;
            this.doNotMatch = "ERROR";
        } else {
            this.doNotMatch = null;
            this.passwordService
                .save(
                    newPassword,
                    this.passwordForm.get(["currentPassword"]).value,
                )
                .subscribe(
                    () => {
                        this.error = null;
                        this.success = "OK";
                    },
                    (error) => {
                        this.success = null;
                        this.error = error.error.detail;
                    },
                );
        }
    }
}
